import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ChildrenPropType } from '../../services/proptypes';
import { getSiteKey } from './RecaptchaProvider.utils';
import './RecaptchaProvider.css';
var defaultProps = {
  siteKey: getSiteKey()
};
export default function RecaptchaProvider(_ref) {
  var children = _ref.children,
      siteKey = _ref.siteKey;

  if (!siteKey) {
    return children;
  }

  return /*#__PURE__*/React.createElement(GoogleReCaptchaProvider, {
    reCaptchaKey: siteKey,
    language: "en",
    useRecaptchaNet: false,
    useEnterprise: true,
    scriptProps: {
      async: false,
      defer: false,
      appendTo: 'head',
      nonce: undefined
    }
  }, children);
}
RecaptchaProvider.defaultProps = defaultProps;